import { useEffect } from "react";

import { SiteFooter } from "../components/SiteFooter";
import { SiteHeader } from "../components/SiteHeader";

export function NotFoundPage() {
  usePageMetadata("Page not found — Backbone", "https://backbonesystems.ai/404");

  return (
    <div className="site-frame not-found-page">
      <SiteHeader />
      <main className="page-shell not-found">
        <section className="content-column" aria-labelledby="not-found-title">
          <p className="page-kicker">404</p>
          <h1 id="not-found-title">This page has moved.</h1>
          <p>The useful path is back this way.</p>
          <a className="text-link" href="/">
            Return home <span aria-hidden="true">→</span>
          </a>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}

function usePageMetadata(title: string, canonical: string) {
  useEffect(() => {
    document.title = title;
    document
      .querySelector<HTMLLinkElement>('link[rel="canonical"]')
      ?.setAttribute("href", canonical);
  }, [canonical, title]);
}
